import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  isLoading: true,
};

const trailerArrivalSlice = createSlice({
  name: "trailerArrivalSlice",
  initialState,
  reducers: {
    setNotification: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export default trailerArrivalSlice.reducer;

export const { setNotification } = trailerArrivalSlice.actions;
